const INITIAL_STATE = {
  token: null,
  idle: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'TOKEN':
      return { ...state, token: action.payload }
    case 'AUTH_IDLE_CHANGE': {
      let idleCopy = state.idle

      if (idleCopy == true) {
        idleCopy = false
      } else {
        idleCopy = true
      }

      return { ...state, idle: idleCopy }
    }
    default:
      return state
  }
}